import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const BaseRteIntroOutroText = styled.div`
  color: ${colors.lightContentGrey};
  background: ${colors.inputGrey};
  padding: 4px 8px;
  font-size: 16px;
  display: inline-block;
  margin: 8px;
  border-radius: 8px;
`;
